import React, { useEffect, useRef, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import logo from "@/assets/images/logo_white.png";
import back_video from "@/assets/videos/Login_background.mp4";
import axiosInstance from "@/api/axios";
import "./Login.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { BiSolidChevronDown } from "react-icons/bi";
import English from "@/assets/images/English.png";
import Dutch from "@/assets/images/Dutch.png";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "@/context/LanguageContext";

const PasswordConfirm = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [succesMsg, setSucessMsg] = useState("");
  const [openeye, setOpeneye] = useState(true);
  const [eyevisible, setEyevisible] = useState(false);
  const [openeye2, setOpeneye2] = useState(true);
  const [eyevisible2, setEyevisible2] = useState(false);
  const [displaydropdown, setDisplayDropDown] = useState(false);
  const errRef = useRef();
  const { setLanguage } = useContext(LanguageContext);
  const [langimage, setLangImage] = useState(localStorage.getItem("langimage") || English);
  const { t, i18n } = useTranslation();
  const { uid, token: urlToken } = useParams();

  useEffect(() => {
    localStorage.setItem("langimage", langimage);
  }, [langimage]);

  const validatePassword = () => {
    if (password !== confirmPassword) {
      setErrMsg("Passwords don't match");
    } else {
      setErrMsg("");
    }
  };

  useEffect(() => {
    validatePassword();
    setErrMsg("");
  }, [password, confirmPassword]);

  const handleDropDownChange = () => {
    setDisplayDropDown(!displaydropdown);
  };

  const handleLanguageChange = (event) => {
    const language = event.target.getAttribute("value");
    let newLangCode = "nl";
    if (language === "English") {
      setLangImage(English);
      newLangCode = "en";
    } else {
      setLangImage(Dutch);
      newLangCode = "nl";
    }
    i18n.changeLanguage(newLangCode);
    setLanguage(language);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let token = urlToken;
    if (!token) {
      const urlParams = new URLSearchParams(window.location.search);
      token = urlParams.get("token");
    }

    const payload = uid
      ? { password, token, uid }
      : { password, token };

    try {
      await axiosInstance.post("user/password_reset/confirm/", payload, {
        withCredentials: true,
      });
      setPassword("");
      setConfirmPassword("");
      setSucessMsg("Password changed successfully");
      localStorage.clear();
      window.location.href = "/login";
    } catch (err) {
      if (err.response?.status === 404) {
        setErrMsg("Token Expired");
      } else if (err.response?.status === 400) {
        setErrMsg("Password not valid");
      }
      errRef.current.focus();
    }
  };

  return (
    <div className="relative h-screen">
      <div className="absolute inset-0 z-0">
        <video className="w-full h-full object-cover" autoPlay muted loop>
          <source src={back_video} type="video/mp4" />
        </video>
      </div>

      <div className="relative z-10 flex">
        <div className="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8 flex items-center justify-center h-screen">
          <div className="mx-auto max-w-lg">

            {/* Logo + Language switcher */}
            <div className="mx-auto w-1/6 pb-5 flex justify-center items-center">
              <div className="relative z-50 bg-white rounded-sm -ml-20" onClick={handleDropDownChange}>
                <button className="flex flex-row items-center justify-center gap-x-1 p-2">
                  <img src={langimage} className="w-6 h-6" />
                  <BiSolidChevronDown />
                </button>
                {displaydropdown && (
                  <ul className="absolute top-[100%] shadow-lg rounded-lg p-2 pr-2 bg-white">
                    <li
                      className="flex items-center justify-start gap-x-1 text-[13px] hover:bg-plaex-light-green p-2 pr-16 rounded-lg cursor-pointer text-black hover:text-black"
                      value="English"
                      onClick={handleLanguageChange}
                    >
                      <img src={English} className="w-6 h-6" />
                      English
                    </li>
                    <li
                      className="flex items-center justify-start gap-x-1 text-[13px] hover:bg-plaex-light-green p-2 pr-16 rounded-lg cursor-pointer text-black hover:text-black"
                      value="Dutch"
                      onClick={handleLanguageChange}
                    >
                      <img src={Dutch} className="w-6 h-6" />
                      Dutch
                    </li>
                  </ul>
                )}
              </div>
              <img src={logo} alt="logo" />
            </div>

            <h1 className="text-center text-2xl font-bold text-green-600 sm:text-3xl">
              {langimage === Dutch ? "Wachtwoord Opnieuw Instellen" : "Reset Your Password"}
            </h1>
            <p className="mx-auto mt-4 max-w-md text-center text-white">
              {langimage === Dutch
                ? "Voer uw nieuwe wachtwoord in om toegang te krijgen"
                : "Enter your new password to regain access"}
            </p>

            <p
              ref={errRef}
              className={errMsg ? "errmsg" : "offscreen"}
              aria-live="assertive"
            >
              {errMsg}
            </p>
            <p
              className={succesMsg ? "successmsg" : "offscreen"}
              aria-live="assertive"
            >
              {succesMsg}
            </p>

            <form
              className="mt-6 mb-0 space-y-4 rounded-lg p-4 shadow-lg sm:p-6 lg:p-8"
              onSubmit={handleSubmit}
            >
              <p className="text-center font-medium text-green-500 text-2xl">
                {langimage === Dutch ? "Nieuw Wachtwoord" : "New Password"}
              </p>

              {/* Password field */}
              <div>
                <label htmlFor="password" className="sr-only">Password</label>
                <div className="relative">
                  <input
                    type={eyevisible ? "text" : "password"}
                    id="password"
                    className="w-full rounded-lg border-2 p-4 pr-12 text-sm shadow-sm focus:border-green-500 focus:outline-none"
                    placeholder={langimage === Dutch ? "Voer nieuw wachtwoord" : "Enter new password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onBlur={validatePassword}
                    required
                  />
                  <span className="absolute inset-y-0 right-0 grid place-content-center px-4 cursor-pointer">
                    {openeye
                      ? <AiOutlineEye className="h-5 w-5 text-gray-400" onClick={() => { setOpeneye(false); setEyevisible(true); }} />
                      : <AiOutlineEyeInvisible className="h-5 w-5 text-gray-400" onClick={() => { setOpeneye(true); setEyevisible(false); }} />
                    }
                  </span>
                </div>
              </div>

              {/* Confirm password field */}
              <div>
                <label htmlFor="confirm-password" className="sr-only">Confirm Password</label>
                <div className="relative">
                  <input
                    type={eyevisible2 ? "text" : "password"}
                    id="confirm-password"
                    className="w-full rounded-lg border-2 p-4 pr-12 text-sm shadow-sm focus:border-green-500 focus:outline-none"
                    placeholder={langimage === Dutch ? "Bevestig nieuw wachtwoord" : "Confirm new password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onBlur={validatePassword}
                    required
                  />
                  <span className="absolute inset-y-0 right-0 grid place-content-center px-4 cursor-pointer">
                    {openeye2
                      ? <AiOutlineEye className="h-5 w-5 text-gray-400" onClick={() => { setOpeneye2(false); setEyevisible2(true); }} />
                      : <AiOutlineEyeInvisible className="h-5 w-5 text-gray-400" onClick={() => { setOpeneye2(true); setEyevisible2(false); }} />
                    }
                  </span>
                </div>
              </div>

              <button
                type="submit"
                className="block w-full rounded-lg bg-green-600 px-5 py-3 text-sm font-medium text-white hover:bg-green-400 hover:text-gray-800"
              >
                {langimage === Dutch ? "Wachtwoord Opnieuw Instellen" : "RESET PASSWORD"}
              </button>

              <div className="flex justify-center">
                <a href="/login">
                  <p className="text-green-600 pt-2 underline">
                    {langimage === Dutch ? "Terug naar aanmelden" : "Back to Login"}
                  </p>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordConfirm;